import { render, staticRenderFns } from "./PolarareaChart.vue?vue&type=template&id=276c8215&"
import script from "./PolarareaChart.vue?vue&type=script&lang=js&"
export * from "./PolarareaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports